"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppSelector = exports.useAppDispatch = void 0;
// eslint-disable-next-line no-restricted-imports
const react_redux_1 = require("react-redux");
exports.useAppDispatch = react_redux_1.useDispatch;
exports.useAppSelector = react_redux_1.useSelector;
//# sourceMappingURL=hooks.js.map